// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-calendar-heatmap/dist/vue-calendar-heatmap.css
// module id = jCvb
// module chunks = 1